export enum JobSubmissionsActionTypes {
    API_RESPONSE_SUCCESS = '@@jobSubmissions/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@jobSubmissions/API_RESPONSE_ERROR',
    JOB_SUBMISSIONS_LIST = '@@jobSubmissions/JOB_SUBMISSIONS_LIST',
}

